/**
 * Sillage storefront behaviour: quiet fade-ins, the landing arrow, and header state.
 * No scroll hijacking, no parallax. Honours prefers-reduced-motion.
 */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var hasIO = 'IntersectionObserver' in window;

  /* Fade-ins: add .is-in the first time an element is comfortably on screen. */
  function initReveals() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;
    if (reduce.matches || !hasIO) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.12 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  /* Landing arrow: smooth scroll to the next section (instant when reduced motion is on). */
  function initScrollArrow() {
    document.querySelectorAll('[data-scroll-next]').forEach(function (a) {
      if (a.__slBound) return;
      a.__slBound = true;
      a.addEventListener('click', function (e) {
        var id = (a.getAttribute('href') || '').replace('#', '');
        var target = id && document.getElementById(id);
        if (!target) {
          var wrap = a.closest('.shopify-section');
          var next = wrap && wrap.nextElementSibling;
          target = next && next.firstElementChild;
        }
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' });
        if (id && history.replaceState) history.replaceState(null, '', '#' + id);
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      });
    });
  }

  /* Header: hidden over the landing photograph (it already carries the logo), then fades in.
     It also switches to cream text when it sits over a dark section. */
  function initHeader() {
    var header = document.querySelector('[data-sl-header]');
    if (header && header.__slInit) return;
    if (header) header.__slInit = true;
    if (!header || !hasIO) {
      if (header) header.classList.add('is-shown');
      return;
    }
    var hero = document.querySelector('[data-sl-hero]');
    if (hero) {
      new IntersectionObserver(
        function (entries) { header.classList.toggle('is-shown', !entries[0].isIntersecting || entries[0].intersectionRatio < 0.55); },
        { threshold: [0, 0.55, 1] }
      ).observe(hero);
    } else {
      header.classList.add('is-shown');
    }

    var themed = document.querySelectorAll('[data-header-theme]');
    if (!themed.length) return;
    var state = new Map();
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) { state.set(e.target, e.isIntersecting ? e.target.dataset.headerTheme : null); });
        var active = null;
        state.forEach(function (v) { if (v) active = v; });
        header.classList.toggle('on-dark', active === 'dark');
      },
      { rootMargin: '-30px 0px -' + Math.max(0, window.innerHeight - 80) + 'px 0px' }
    );
    themed.forEach(function (el) { io.observe(el); });
  }

  function init() {
    initReveals();
    initScrollArrow();
    initHeader();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Theme editor: re-run after a section is added or edited. */
  document.addEventListener('shopify:section:load', init);
})();
